import { Dispatch } from '../context/UseNewCampaignContext';

export const updateStepValidityAction = (
  valid: boolean,
  validSteps: number[],
  currentStep: number,
  dispatch: Dispatch,
) => {
  dispatch({ type: 'UPDATE_STEP_VALID', payload: { stepValid: valid } });

  let newValidSteps: number[] = [];
  if (valid) {
    newValidSteps = validSteps
      .filter(step => step !== currentStep)
      .concat([currentStep])
      .sort();
  } else {
    newValidSteps = validSteps.filter(step => step !== currentStep).sort();
  }

  dispatch({ type: 'UPDATE_VALID_STEPS', payload: { validSteps: newValidSteps } });
};

export default updateStepValidityAction;
